import logo from "./images/auth-form.png"
import {objectLang} from "./functions"
import {useNavigate} from "react-router-dom"

export const EnterDataButton = ({disabled = true, isRegistration = false, isLogin = true}) => {

    const navigate = useNavigate()
    const lang = objectLang().language
    const l = lang.lang
    let fontSize = l === 'ge' ? '26px' : '26px'

    const handleLogin = () => {
        if (isLogin) {
            navigate(`/${l}/auth-form`, {replace: true})
            // window.location.replace(`/${l}/auth-form`)
        } else if (isRegistration) {
            navigate(`/${l}/register-form`, {replace: true})
            // window.location.replace(`/${l}/register-form`)
        }
    }

    return (
        <button
            onClick={handleLogin}
            style={{
                marginTop: "1rem",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 20px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: fontSize,
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                width: "100%"
            }} disabled={disabled}>
            <img src={logo} alt="Fill the form" width="30" height="30" />
            {lang.body.authPage.titleButton}
        </button>
    )
}
